import classNames from 'classnames';

import {Dialog as LuffyDialog} from '@baidu/luffy-comp-dialog';

import './index.scss';

interface IProps {
    className?: string;
    visible: boolean;
    showFooter?: boolean;
    onConfirm?: () => void;
    onCancel?: () => void;
}

const Dialog: React.FC<IProps> = ({className, visible, children, showFooter = true, onConfirm, onCancel}) => {
    return <LuffyDialog
        visible={visible}
        className={classNames('ku-dialog', className)}
    >
        <div className={'ku-dialog-body'}>
            {children}
        </div>
        {showFooter && <div className={'ku-dialog-footer'}>
            <button className={'ku-dialog-footer-btn ku-dialog-footer-cancel'} onClick={onCancel}>取消</button>
            <button className={'ku-dialog-footer-btn ku-dialog-footer-confirm'} onClick={onConfirm}>确认</button>
        </div>}
    </LuffyDialog>;
};

export default Dialog;
